module.exports = __webpack_public_path__ + "static/media/licenta11.32fbc82a.png";